























































































import {Component, Vue} from 'vue-property-decorator';
import {Mall} from '@/views/claim/dataType/OrderProductOption';
import ComponentNoticeBox from '@/views/claim/components/ComponentNoticeBox.vue';
import ComponentItemsClaim from '@/views/claim/components/ComponentItemsClaim.vue';
import ComponentDiscountShippingFee from '@/views/claim/components/ComponentDiscountShippingFee.vue';
import ComponentProductDetails from '@/views/claim/components/ComponentProductDetails.vue';
import ComponentRefundExchangeAmount from '@/views/claim/components/ComponentRefundExchangeAmount.vue';
import ComponentBenefitsPaid from '@/views/claim/components/ComponentBenefitsPaid.vue';
import {
  PostOptionCancelsPredict,
  GetClaimsOrderOptionsOrderOptionNoApplyRequest,
  PostOptionCancelsRequest,
  PostOptionCancelsPredictRequest,
  RefundType
} from 'supporter';
import {ComponentItemsClaimDataType, ClaimableOption} from '@/views/claim/components/dataType/ComponentDataType';
import {addClass} from '@/utils/classUtils';

@Component({
  components: {
    ComponentNoticeBox,
    ComponentItemsClaim,
    ComponentDiscountShippingFee,
    ComponentProductDetails,
    ComponentRefundExchangeAmount,
    ComponentBenefitsPaid
  }
})
export default class CancelPopup extends Vue {
  private pageName = 'CancelPopup';
  private orderNo?: string;
  private payType?: string;
  private responsibleObjectType!: string;
  private displayedDeliveryAmtDiscountMessage: boolean = false;
  private mall: Mall = {
    countryCd: 'KR'
  };
  private refundTypeDivShow: boolean = true;
  private zeroRefundShow: boolean = false;
  private refundBankInfoTrShow: boolean = true;
  private refundTypeValue: string;
  private postOptionCancelsPredict!: PostOptionCancelsPredict;
  private dataJson: string = '';
  private orderOptionsApply: ComponentItemsClaimDataType = {
    orderNo: '',
    claimableOptions: [],
    refundTypes: []
  };
  private showA: boolean = false;
  private showB: boolean = false;
  private overflowsPgAmt: boolean = false;
  private holdProcess: boolean = false;
  private holdByReservation: boolean = false;
  private errorFlg: boolean = false;
  // private chargeDeliveryAmtDivFlg: boolean = false;
  private claimableOptions!: any[];
  private isShow: boolean = false;

  private created() {
    this.initPostOptionCancelsPredict();
    this.getClaimOrderPredict();
  }

  private getClaimOrderPredict() {
    this.errorFlg = false;
    let request: GetClaimsOrderOptionsOrderOptionNoApplyRequest = {
      pathParams: {
        orderOptionNo: this.$route.query.orderProductOptionNo.toString()
      },
      params: {
        claimType: 'CANCEL'
      }
    };
    this.$api.getClaimsOrderOptionsOrderOptionNoApply(request).then((ret: any) => {
      this.isShow = true;
      this.holdProcess = false;
      this.holdByReservation = false;

      ret.data.claimableOptions.forEach((item: any) => {
        let claimableOption: ClaimableOption = {
          ...item,
          checkboxValue: item.orderOptionNo == ret.data.claimedOption.orderOptionNo,
          mallOptionNo: item.mallOptionNo,
          userInputText: item.userInputText,
          orderNo: item.orderNo,
          immediateDiscountAmt: item.immediateDiscountAmt,
          salePrice: item.salePrice,
          orderStatusType: item.orderStatusType,
          optionValue: item.optionValue,
          orderCnt: item.orderCnt,
          addPrice: item.addPrice,
          mallProductNo: item.mallProductNo,
          claimedCnt: item.claimedCnt,
          productName: item.productName,
          claimStatusType: item.claimStatusType,
          additionalDiscountAmt: item.additionalDiscountAmt,
          optionName: item.optionName,
          orderOptionNo: item.orderOptionNo,
          partnerNo: Number(ret.data.partnerNo),
          partnerName: ret.data.partnerName,
          payType: '',
          productUrl: item.productUrl,
          holdProcess: item.holdProcess,
          holdByReservation: item.holdByReservation || this.holdByReservation,
          optionManagementCd: item.optionManagementCd,
          usesOption: item.usesOption,
          hasSetOption: item.hasSetOption,
          setOptions: item.setOptions
        };
        this.holdProcess = item.holdProcess || this.holdProcess;
        this.holdByReservation = item.holdByReservation || this.holdByReservation;
        this.orderOptionsApply.claimableOptions.push(claimableOption);
      });
      this.orderOptionsApply.refundTypes = ret.data.refundTypes;
      this.orderOptionsApply.orderNo = ret.data.claimedOption.orderNo;
      this.orderOptionsApply.payType = ret.data.payType;
      this.showA = true;
      this.responsibleObjectType = 'BUYER';
    })
    .catch((error: any) => {
      // alert(error.data.message);
      window.opener.location.reload();
      window.close();
    });
  }

  private objJson = '';
  private setData(predict) {
    this.$nextTick(() => {
      let request: PostOptionCancelsPredictRequest;
      if(predict === 'postPredict') {
        request = {
          data: {
            responsibleObjectType: (this.$refs.componentItemsClaim as any).responsibleObjectTypeValue,
            refundType: (this.$refs.componentRefundExchangeAmount as any).refundTypeValue,
            orderNo: this.orderOptionsApply.orderNo,
            sellerPaysClaimedDelivery: (this.$refs.componentProductDetails as any).chargeDeliveryAmt,
            orderOptionParams: (this.$refs.componentItemsClaim as any).orderOptionParams,
          }
        };
      } else {
        const refundType = this.orderOptionsApply.payType === 'NAVER_PAY' ? this.findNaverRefundType() : this.orderOptionsApply.refundTypes[0].refundType as RefundType
        request = {
          data: {
            responsibleObjectType: 'BUYER',
            refundType,
            orderNo: this.orderOptionsApply.orderNo,
            sellerPaysClaimedDelivery: false,
            orderOptionParams: (this.$refs.componentItemsClaim as any).orderOptionParams,
          }
        };
      }

      this.$api.postOptionCancelsPredict(request).then((ret: any) => {
        this.showB = true;
        this.postOptionCancelsPredict = ret.data;
        this.objJson = JSON.stringify(this.postOptionCancelsPredict);
        this.overflowsPgAmt = ret.data.overflowsPgAmt;
        this.refundTypeValue = this.getPayType(this.orderOptionsApply.payType);
        this.postOptionCancelsPredict.amounts.refund.order.totalDeliveryAmt = this.postOptionCancelsPredict.amounts.refund.coupon.cartCouponDiscountAmt - this.postOptionCancelsPredict.amounts.refund.delivery.totalDeliveryAmt;
        this.displayedDeliveryAmtDiscountMessage = this.postOptionCancelsPredict.amounts.before.delivery.deliveryGroupAmounts.alreadyPaidTotalDeliveryAmt !== this.postOptionCancelsPredict.amounts.before.delivery.deliveryGroupAmounts.totalDeliveryAmt
	      if(this.postOptionCancelsPredict.amounts.adjustedAmounts.claimAmt === 0) {
          this.refundTypeDivShow = false;
          this.zeroRefundShow = true;
          this.refundBankInfoTrShow = false;
          this.refundTypeValue = 'ZERO_REFUND';
        } else {
		      this.refundTypeDivShow = true;
		      this.zeroRefundShow = false;
		      this.refundBankInfoTrShow = true;
		      this.refundTypeValue = this.postOptionCancelsPredict.refundType;
	      }
      });
    });
  }

  private findNaverRefundType(): RefundType{
    if(this.orderOptionsApply.payType !== 'NAVER_PAY'){
      return this.orderOptionsApply.refundTypes[0].refundType as RefundType;
    }

    // label은 서버에서 한글로 내려주기 때문에 한글로 비교
    return this.orderOptionsApply.refundTypes.find(({refundType, label}) => refundType==='PG' && label === '네이버페이(주문형)').refundType as RefundType
  }

  public getPayType(payType: string) {
    switch (payType) {
      case 'ACCOUNT':
        return 'ACCOUNT'

      case 'ACCUMULATION':
        return 'ACCUMULATION'

      case 'ZERO_PAY':
        return 'ZERO_REFUND'

      case 'VIRTUAL_ACCOUNT':
      case 'ESCROW_VIRTUAL_ACCOUNT':
        return 'PG';

      default:
        return 'PG';
    }
  }

  private initPostOptionCancelsPredict() {
    let postOptionCanclesPredictTemp: any = {
      shipping: {
        requiresShipping: true,
        address: {
          address: '',
          name: '',
          jibunAddress: '',
          detailAddress: '',
          zipCd: '',
          contact1: '',
          contact2: ''
        },
        shippingNo: 0,
        hasAdjustedExchangeDeliveryAmt: false,
        divided: true,
        deliveryGroupNo: 0,
        deliveryType: '',
        prepaid: true,
        deliveryTemplateNo: 0,
        combined: true,
        originalShippingNo: 0
      },
      coupon: {
        productCoupons: [
          {
            couponName: '',
            couponIssueNo: 0,
            orderProductNo: 0,
            restores: false,
            couponNo: 0
          }
        ],
        cartCoupon: {
          couponName: '',
          couponIssueNo: 0,
          orderProductNo: 0,
          restores: false,
          couponNo: 0
        }
      },
      amounts: {
        deliveryAdjustAmt: 0,
        additionalDeliveryAmt: 0,
        adjustedAmounts: {
          mainPayAmt: 0,
          accumulationPayAmt: 0,
          claimAmt: 0,
          additionalPayAmt: 0,
          payAmt: 0
        },
        before: {
          delivery: {
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            deliveryGroupAmounts: {
              prepaidRemoteDeliveryAmt: 0,
              payOnRemoteDeliveryAmt: 0,
              deliveryAmt: 0,
              remoteDeliveryAmt: 0,
              payOnDeliveryAmt: 0,
              totalDeliveryAmt: 0,
              prepaidDeliveryAmt: 0,
              totalPrepaidDeliveryAmt: 0
            }
          },
          coupon: {
            cartCouponDiscountAmt: 0,
            productCouponDiscountAmt: 0
          },
          accumulation: {
            accumulationAmt: 0
          },
          order: {
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0,
            standardAmt: 0,
            mainPayAmt: 0,
            accumulationPayAmt: 0,
            remainingPgPayAmt: 0,
            payAmt: 0
          }
        },
        after: {
          delivery: {
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            deliveryGroupAmounts: {
              prepaidRemoteDeliveryAmt: 0,
              payOnRemoteDeliveryAmt: 0,
              deliveryAmt: 0,
              remoteDeliveryAmt: 0,
              payOnDeliveryAmt: 0,
              totalDeliveryAmt: 0,
              prepaidDeliveryAmt: 0,
              totalPrepaidDeliveryAmt: 0
            }
          },
          coupon: {
            cartCouponDiscountAmt: 0,
            productCouponDiscountAmt: 0
          },
          accumulation: {
            accumulationAmt: 0
          },
          order: {
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0,
            standardAmt: 0,
            mainPayAmt: 0,
            accumulationPayAmt: 0,
            remainingPgPayAmt: 0,
            payAmt: 0
          }
        },
        additionalPayAmt: 0,
        refund: {
          delivery: {
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            deliveryGroupAmounts: {
              prepaidRemoteDeliveryAmt: 0,
              payOnRemoteDeliveryAmt: 0,
              deliveryAmt: 0,
              remoteDeliveryAmt: 0,
              payOnDeliveryAmt: 0,
              totalDeliveryAmt: 0,
              prepaidDeliveryAmt: 0,
              totalPrepaidDeliveryAmt: 0
            }
          },
          coupon: {
            cartCouponDiscountAmt: 0,
            productCouponDiscountAmt: 0
          },
          accumulation: {
            accumulationAmt: 0
          },
          order: {
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0,
            standardAmt: 0,
            mainPayAmt: 0,
            accumulationPayAmt: 0,
            remainingPgPayAmt: 0,
            payAmt: 0
          }
        }
      },
      overflowsPgAmt: false
    };
    this.postOptionCancelsPredict = postOptionCanclesPredictTemp;
    this.objJson = JSON.stringify(postOptionCanclesPredictTemp);
  }

  private alertMessageForFreeGift(selectedOptionNos) {
    const hasTargetProduct = this.orderOptionsApply.claimableOptions.filter(option => selectedOptionNos.includes(option.orderOptionNo)).some(({ isGivenFreeGift }) => isGivenFreeGift);
    if (hasTargetProduct) {
      alert('사은품이 지급된 대상상품이 포함되어있습니다. \n사은품 지급 철회가 필요한 경우 \n사은품 상품도 클레임 처리해 주세요.');
      return;
    }

    const hasFreeGiftProduct = this.orderOptionsApply.claimableOptions.filter(option => selectedOptionNos.includes(option.orderOptionNo)).some(({ isFreeGift }) => isFreeGift);
    if (hasFreeGiftProduct) {
      alert('사은품 상품이 포함되어 있습니다. \n사은품 지급 대상상품의 클레임 처리가 필요한 경우 \n별도 처리해 주세요.');
    }
  }

  private onClickApplyCancel() {
    const selectedOptionNos = (this.$refs.componentItemsClaim as any).optionno;
    this.alertMessageForFreeGift(selectedOptionNos);

    let orderOptionParams: any = [];
    for (let i = 0; i < (this.$refs.componentItemsClaim as any).optionno.length; i++) {
      let claimCnt = (this.$refs.componentItemsClaim as any).orderCntMap.get((this.$refs.componentItemsClaim as any).optionno[i]) || 0;

      orderOptionParams.push({
        claimCnt: claimCnt,
        orderOptionNo: (this.$refs.componentItemsClaim as any).optionno[i]
      });
    }


    let bank = '';
    let bankNm = '';
    if((this.$refs.componentRefundExchangeAmount as any).refundBankEditShow === false) {
      bank = null
      bankNm = null
    } else {
      bank = (this.$refs.componentRefundExchangeAmount as any).refundBankValue;
      (this.$refs.componentRefundExchangeAmount as any).refundBankList.forEach((element: {value: string; name: string}) => {
        if (element.value == (this.$refs.componentRefundExchangeAmount as any).refundBankValue) {
          bankNm = element.name;
        }
      });
    }
    let request: PostOptionCancelsRequest = {
      data: {
        reasonDetail: (this.$refs.componentItemsClaim as any).claimReasonDetail,
        calculateParam: {
          refundType: (this.$refs.componentRefundExchangeAmount as any).claimTotal === 0 ? 'ZERO_REFUND' : (this.$refs.componentRefundExchangeAmount as any).refundTypeValue,
          responsibleObjectType: (this.$refs.componentItemsClaim as any).responsibleObjectTypeValue,
          orderNo: this.orderOptionsApply.orderNo,
          sellerPaysClaimedDelivery: (this.$refs.componentProductDetails as any).chargeDeliveryAmt,
          orderOptionParams: orderOptionParams
        },
        reasonType: (this.$refs.componentItemsClaim as any).claimReasonType,
        refundBankAccount: {
          depositorName: (this.$refs.componentRefundExchangeAmount as any).refundBankDepositorName,
          bank: bank,
          bankName: bankNm,
          account: (this.$refs.componentRefundExchangeAmount as any).refundBankAccount
        }
      }
    };

    if (this.overflowsPgAmt && (this.$refs.componentRefundExchangeAmount as any).refundTypeValue != 'ACCOUNT' && (this.$refs.componentRefundExchangeAmount as any).refundTypeValue != 'ACCUMULATION') {
      alert(this.$t('CLAIM_CANCELPOPUP_ALTER'));
      return;
    }
    if (!this.validation()) {
      return;
    }

    if (!confirm(this.$t('CLAIM_CANCELPOPUP_CONFIRM1').toString())) {
      return;
    }

    this.$api.postOptionCancels(request).then((): any => {
      alert(this.$t('CLAIM_CANCELPOPUP_PROCESS_SUCCESS_MESSAGE'));
      window.opener.location.reload();
      this.close();
    });
  }

  private checkHoldByReservation(): boolean {
    return this.holdByReservation == true && !confirm(this.$t('CLAIM_CANCELPOPUP_RESERVATION_CONFIRM').toString());
  }
  private checkHoldDelivery(): boolean {
    return this.holdProcess == true && !confirm(this.$t('CLAIM_CANCELPOPUP_CONFIRM').toString());
  }
  private validation(): boolean {
    if (this.checkHoldDelivery()) {
      return false;
    }
    if (this.checkHoldByReservation()) {
      return false;
    }

    if (this.postOptionCancelsPredict.amounts.adjustedAmounts.payAmt != 0) {
        if ((this.$refs.componentItemsClaim as any).optionno.length == 0) {
            alert(this.$t('CLAIM_CANCELPOPUP_SELECT_ONE', {type: this.$t('CLAIM_COMMON_CANCEL')}));
            (this.$refs.componentRefundExchangeAmount as any).$refs.refundBankAccountRef.focus();
            return false;
        }

      let needBankAccount = false
      switch ((this.$refs.componentRefundExchangeAmount as any).refundTypeValue) {
        case 'CASH':
        case 'ACCOUNT':
          needBankAccount = true;
          break;
        case 'PG':
          if(this.orderOptionsApply.payType === 'VIRTUAL_ACCOUNT' || this.orderOptionsApply.payType === 'ESCROW_VIRTUAL_ACCOUNT') {
            needBankAccount = true;
          }
          break;
      }

      if (needBankAccount && ((this.$refs.componentRefundExchangeAmount as any).refundBankValue == null || (this.$refs.componentRefundExchangeAmount as any).refundBankValue == '')) {
        alert(this.$t('CLAIM_CANCELPOPUP_ALTER1'));
        (this.$refs.componentRefundExchangeAmount as any).$refs.refundBankAccountRef.focus();
        return false;
      }

      if (needBankAccount && (this.$refs.componentRefundExchangeAmount as any).refundBankAccount == '') {
        alert(this.$t('CLAIM_CANCELPOPUP_ALTER2'));
        (this.$refs.componentRefundExchangeAmount as any).$refs.refundBankAccountRef.focus();
        return false;
      }

      if (needBankAccount && (this.$refs.componentRefundExchangeAmount as any).refundBankDepositorName == '') {
        alert(this.$t('CLAIM_CANCELPOPUP_ALTER3'));
        (this.$refs.componentRefundExchangeAmount as any).$refs.refundBankDepositorNameRef.focus();
        return false;
      }
    }
    return true;
  }

  public close(): void {
    window.close();
  }

  public popupResize(): void {
    let contentWidth = $('#container').width() + 30;
    let contentHeight = $('#container').height() + 76;
    window.resizeTo(contentWidth, contentHeight);
  }

  public mounted() {
    addClass(document.body, 'popup popup_large');
    setTimeout(() => {this.popupResize()},1000);
  }

}
